<template>
  <!-- 成员信息 -->
  <el-dialog
    v-model="memberVisible"
    title="选择报名用户"
    width="500px"
  > 
    <div v-loading="loading" style="min-height: 300px">
      <div class="user-box flex" v-for="(v, i) in memberData" :key="v.id" :class="[memberIndex == i ? 'on' : '']" @click="memberIndex = i">
        <div class="tips" v-if="v.type == 1">已报名</div>
        <div class="head_icon">
          <img src="./images/man.png" alt="" v-if="memberType == 0">
          <img src="./images/woman.png" alt="" v-else-if="memberType == 1">
          <img src="./images/boy.png" alt="" v-else-if="memberType == 2">
          <img src="./images/girl.png" alt="" v-else-if="memberType == 3">
        </div>
        <div class="info-box flex-item flex">
          <div class="flex box-1">
            <div class="txt flex-item">姓名：{{v.truename}}</div>
            <div class="txt flex-item">性别：男</div>
          </div>
          <div class="txt box-2">身份证：{{v.idcard}}</div>
        </div>
      </div>
      <div class="add-user flex" @click="goUser()">
        <div class="title">添加成员</div>
        <div class="tip">您还可以添加家庭成员</div>
      </div>
    </div>
    
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="memberVisible = false">取消报名</el-button>
        <el-button type="primary" @click="HandelBtn">报名</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { reactive, toRefs, watch } from "vue"
import { getAgeIdcard, getSexIdcard } from "@/tools"
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
export default {
  name: "memberIndex",
  emits: ['choiceUser'],
  setup(props, context) {
    const Router = useRouter()
    let initData = reactive({
      loading: true,
      memberVisible: false,    // 选择成员
      memberData: "",
      memberIndex: 0,

      memberType: -1, // 0：男-大人 1：女-大人 2：男-小孩 3：女-小孩

      getAgeIdcard,
      getSexIdcard
    })
    watch(() => initData.memberData, (value) => {
      value.forEach(item => {
        // console.log(getSexIdcard(item.idcard))
        if(getSexIdcard(item.idcard)[0] === 0) {
          if(getAgeIdcard(item.idcard) >= 18) {
            initData.memberType = 0
          } else {
            initData.memberType = 2
          }
        } else {
          if(getAgeIdcard(item.idcard) >= 18) {
            initData.memberType = 1
          } else {
            initData.memberType = 3
          }
        }
      })
    })
    function HandelBtn() {
      if(initData.memberData.length == 0) {
        ElMessage({
          message: '您还未绑定任何成员.',
          type: 'warning',
        })
        return
      }
      context.emit("choiceUser", initData.memberData[initData.memberIndex])
      
    }
    function goUser() {
      Router.push({
        path: "/user/index"
      })
    }
    return {
      ...toRefs(initData),
      HandelBtn,
      goUser
    }
  }
}
</script>

<style lang="less" scoped>

// 用户
.user-box {
  height: 110px;
  
  padding: 15px;
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3), 0 0 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &:hover {
    background: linear-gradient(-90deg,#97a7ee,#e4ebf3);
  }
  .tips {
    padding: 3px 10px;
    position: absolute;
    right: 0;
    top: 0;
    background-color: #ff9800;
    border-radius: 0 0 0 5px;
  }
  .head_icon {
    font-size: 0;
    img {
      height: 80px;
    }
  }
  .info-box {
    margin-left: 20px;
    // align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    .box-2 {
      margin-top: 10px;
    }
    
  }
  
}
.user-box.on {
  background: linear-gradient(-90deg,#4567fe,#5ba4fe);
  color: #fff;
}
.add-user {
  height: 90px;
  border: 1px dashed #49cd9d;
  padding: 15px;
  box-sizing: border-box;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  background: #f4f4f5;
  border-radius: 4px;
  &:hover {
    border-color: #ff9800;
    &:before,&::after {
      background-color: #ff9800;
    }
  }
  &::before {
    content: " ";
    width: 2px;
    height: 40px;
    background-color: #49cd9d;
    border-radius: 3px;
    position: absolute;
    top: 25px;
    right: 44px;
  } 
  &::after {
    content: " ";
    width: 40px;
    height: 2px;
    background-color: #49cd9d;
    border-radius: 3px;
    position: absolute;
    top: 44px;
    right: 25px;
  } 
  .title {
    font-size: 20px;
    color: #585858;
    letter-spacing: 2px;
  }
  .tip {
    color: #9e9e9e;
    margin-top: 10px;
    letter-spacing: 1px;
  }
}
</style>